import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function CardSelectTest(props) {
  const [random, setRandom] = useState();
  const [update, setUpdate] = useState(false);
  const [select, setSelect] = useState(false);
  const [uniqOtherTestName, setUniqueOtherTestName] = useState([]);
  const globalSearch = useSelector((state) => state.auth.search);
  const searchKey = useSelector((state) => state.auth.searchKeywords);

  console.log(props, "partner_uuid")
  console.log(props.recPartnerUuid, props.val.doc.partner_uuid, "propsprops")
  useEffect(() => {
    if (props) {
      let count = parseInt(Math.floor(Math.random() * 4));
      if (count) {
        setRandom(count);
      }
    }
  }, []);

  useEffect(() => {
    if (props.recommendedTest) {
      props.handleItems(props.val, props.val);
    }
  }, [props.recommendedTest]);

  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );


  const manageSelectedStyle = () => {
    if (selected_test) {
      if (
        JSON.stringify(selected_test).includes(
          props.val && props.val.doc.testname_uuid
        )
      ) {
        if (
          JSON.stringify(selected_test).includes(
            props.val && props.val.doc.uuid
          )
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  };

  function getHighlightedText(text, highlight) {
    // Split on highlight term and include term into parts, ignore case
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return <span> {parts.map((part, i) =>
      <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { fontWeight: 'normal', backgroundColor: '#FFAD05', fontSize: '11px' } : { fontWeight: 'normal', fontSize: '11px', }}>
        {part}
      </span>)
    } </span>;
  }

  const customizeOtherTestName = (otherNameData) => {
    let uniqData = [...new Set(otherNameData)];
    return uniqData.map((item, index) => {
      // if (item !== props.heading) {
      if (searchKey && props.cardType === "SEARCH") {
        return (
          <span key={index}>{getHighlightedText(item && item.toString().trim(), globalSearch && globalSearch.name.toString().trim())}</span>
        );
      } else {
        return (
          <>
            {/* <span style={{ fontWeight: 'normal', fontSize: '11px' }}>
            <span>{getHighlightedText(item && item.toString().trim(), globalSearch && globalSearch.name.toString().trim())}</span>,
            </span> */}
            {item}
          </>
        );
      }

      // }
    });
  };



  return (
    <div
      className="CardSelectTest"
      style={manageSelectedStyle() ? { border: "2px solid #FFAD05" } : {}}
    >
      {/* <div class="row">
        <div class="col-md-5"></div>
        <div class="col-md-7">
          {props.recPartnerUuid == "PTN-18E0687B" && <div style={{color:"blue", backgroundColor:"#ADD8E6", margin:"5px", padding:"5px"}}>recomeded partner</div> }
        </div>
      </div> */}
      {/* {props.recPartnerUuid == props.val.doc.partner_uuid && <div style={{color:"red", backgroundColor:"blueviolet"}}>recomended test</div> } */}
      <div
        className="headerContainer"
        style={
          manageSelectedStyle()
            ? { background: "#FFFBF2" }
            : { background: "#F6F9FF" }
        }
      >
        <div
          className="headtext"
          style={
            JSON.stringify(selected_test ? selected_test : []).includes(
              props.val ? props.val.doc.testname_uuid : ""
            )
              ? { color: "#66490D" }
              : {}
          }
        >
          {props && props.heading && props.heading !== undefined
            ? props.heading
            : ""}
          <br></br>
        </div>
        <div
          className="sub-head-text"
          style={
            JSON.stringify(selected_test ? selected_test : []).includes(
              props.val ? props.val.doc.testname_uuid : ""
            )
              ? { color: "#66490D" }
              : {}
          }
        >
          {props.val &&
            props.val.other_name &&
            customizeOtherTestName(props.val.other_name).length !== 0
            ? `Other Test names:`
            : `${props && props.subHeading && props.subHeading !== undefined
              ? props.subHeading : ''}`}
          <br></br>
          {props.val &&
            props.val.other_name &&
            props.val.other_name.length > 0 &&
            customizeOtherTestName(props.val.other_name)
          }
          {console.log(props.val.other_name, "props.val.other_name")}
        </div>
      </div>
      <div className="CardTxt">
        {props.des && props.des !== null ? props.des : ""}
        {/* {props.index !== props.length - 1 ? ', ' : ''} */}
        {/* {props.dumb && props.dumb !== null ? props.dumb : ""} */}
      </div>
      {console.log(props.val, "fhdghsjhdjfhfd")}
      <div className={props.recPartnerUuid == "PTN-18E0687B" ? "price1" : "price"}>
        {Number(props.val.min).toFixed() === Number(props.val.max).toFixed() ?
          <small>₦{Number(props.val.max).toFixed()}</small>
          :
          <>
            <small>₦{Number(props.val.min).toFixed()} - </small>
            <small>₦{Number(props.val.max).toFixed()} </small>
          </>
        }
      </div>
      {manageSelectedStyle() ? (
        <div
          style={
            manageSelectedStyle()
              ? { background: "#FFFFFF", color: "#66490D" }
              : {}
          }
          className="Card_btn"
          onClick={() => props.handleItemDelete(props.val)}
        >
          Remove Test
        </div>
      ) : !props &&
        !props.addedItems &&
        !props.addedItems.includes(props.val) ? (
        <div
          className="Card_btn"
          style={{ color: "#163E8C" }}
          onClick={() => props.handleItems(props.val, props.val)}
        >
          BUY TEST
        </div>
      ) : (
        <div
          className="Card_btn"
          style={{ color: "#fff" }}
          onClick={() => props.handleItems(props.val, props.val)}
        >
          Select Test
        </div>
      )}
    </div>
  );
}

export default CardSelectTest;
